import { WizAuthority } from "@/containers/common";

export default columns = (initialValue,_onchange = (e,v)=>{}) => [
  {
    title: "管理权限",
    name: "authCmd",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      onChange:_onchange,
      hasRadioGroup:false,
      initialValue,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"]
    },
  }
]